const ProjectIcon = () => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.07908 7.7417L-0.000976562 13.6796V2.74919C-0.000976562 1.37019 0.995616 0.249023 2.22139 0.249023H6.30152C6.89183 0.249023 7.45784 0.510759 7.87454 0.97954L8.79473 2.01476C9.21143 2.48354 9.77744 2.74528 10.3678 2.74528L14.4444 2.74919C15.6702 2.74919 16.6668 3.87035 16.6668 5.24935V6.49943H4.99935C4.20763 6.49943 3.47842 6.97212 3.07908 7.7417ZM4.03748 8.37064C4.23888 7.9839 4.60349 7.74951 4.99935 7.74951H18.8891C19.2885 7.74951 19.6531 7.98781 19.851 8.37846C20.0489 8.76911 20.0489 9.2457 19.8475 9.63245L15.9584 17.1329C15.7605 17.5158 15.3959 17.7502 15 17.7502H1.11021C0.710875 17.7502 0.346268 17.5119 0.148339 17.1212C-0.0495908 16.7306 -0.0495908 16.254 0.151811 15.8672L4.04095 8.36674L4.03748 8.37064Z"
      fill="black"
    />
  </svg>
);

export default ProjectIcon;
